import {
  PermissionRouteGuard,
  type PermissionRouteGuardData,
} from '@exam-management/permission-route-guard';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { SingleQuestionDetailsProvider } from '@exam-management/question-creation-task-question-management';
import { useParams } from '@exam-management/router';
import { Outlet } from 'react-router-dom';

export default function SingleQuestionCreationLayout() {
  const { taskId, questionId } = useParams(
    '/task-management/question-creation/:taskId/single/:questionId',
  );

  const defaultRoutes: PermissionRouteGuardData[] = [
    {
      path: '/task-management/question-creation/:taskId/single/:questionId',
      requiredPermission: [APP_PERMISSIONS.TASK.QUESTION_CREATION.VIEW],
      params: {
        taskId,
        questionId,
      },
    },
  ];

  return (
    <PermissionRouteGuard routes={defaultRoutes}>
      <SingleQuestionDetailsProvider taskId={taskId} questionId={questionId}>
        <Outlet />
      </SingleQuestionDetailsProvider>
    </PermissionRouteGuard>
  );
}
